import React from 'react';

import RichTextEditorContent from '../../RichTextEditor/components/RichTextEditorContent';

import styles from './ExperienceDescriptionRichTextEditor.module.scss';

const experienceClassNames = {
  container: styles.experienceEditorContainer,
  paragraph: styles.paragraph,
  citation: styles.citation,
};

const ExperienceDescriptionRichTextEditor = ({
  setState,
  state,
  contentEditable,
}) => {
  return (
    <RichTextEditorContent
      state={state}
      setState={setState}
      contentEditable={contentEditable}
      classNames={experienceClassNames}
    />
  );
};

export default ExperienceDescriptionRichTextEditor;
